import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { useLock } from '../context/LockContext';
import ChangePinModal from './ChangePinModal';
import Icon from './Icon';
import { storage } from '../utils/storage';
import './UserMenu.css';

function UserMenu({ onClose }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const { hasPin } = useLock();
  const [showChangePinModal, setShowChangePinModal] = useState(false);
  // Citame is single-business per user (NER-1563). The tenant context is set at
  // login by AuthContext, so there is no restaurant/org switcher — just show the
  // active business name as a read-only label.
  const businessName = storage.get('selectedOrganizationName');

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
      onClose();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  const handleChangePinClick = () => {
    setShowChangePinModal(true);
  };

  const handleClosePinModal = () => {
    setShowChangePinModal(false);
  };

  return (
    <>
      <div className="user-menu-dropdown">
        <div className="user-menu-header">
          <div className="user-menu-avatar">
            {user?.attributes?.charAt(0).toUpperCase() ||
              user?.username?.charAt(0).toUpperCase() || <Icon name="person" size="small" />}
          </div>
          <div className="user-menu-info">
            <p className="user-menu-name">{user?.attributes || user?.username}</p>
            <p className="user-menu-email">{user?.attributes || user?.username}</p>
          </div>
        </div>

        <div className="user-menu-divider"></div>

        {businessName && (
          <div className="user-menu-section">
            <div className="user-menu-section-title">{t('users.business', 'Negocio')}</div>
            <div className="user-menu-business">
              <Icon name="business" size="small" className="option-icon" />
              <span>{businessName}</span>
            </div>
          </div>
        )}

        {hasPin && (
          <div className="user-menu-section">
            <div className="user-menu-section-title">{t('lock.security')}</div>
            <button type="button" onClick={handleChangePinClick} className="user-menu-option">
              <Icon name="vpn_key" size="small" className="option-icon" />
              <span>{t('lock.changePin')}</span>
            </button>
          </div>
        )}

        <div className="user-menu-divider"></div>

        <button type="button" onClick={handleLogout} className="user-menu-logout">
          <Icon name="logout" size="small" className="logout-icon" />
          <span>{t('auth.logout')}</span>
        </button>
      </div>

      {showChangePinModal && <ChangePinModal onClose={handleClosePinModal} />}
    </>
  );
}

export default UserMenu;
